import { generatePath } from 'react-router-dom';
import {
  formatDate,
  formatBalance,
  BaseTransaction,
  BaseellaStatusTitle,
} from '@ui/src';
import ROUTES from '../../../routes';

const formatExportList = ({
  list,
  bankId,
  accountId,
  isCreate,
  batchId,
}: {
  list?: BaseTransaction[];
  bankId: string;
  accountId: string;
  batchId: string;
  isCreate?: boolean;
}): BaseTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let url;

    if (isCreate) {
      url = generatePath(ROUTES.EXPORT_BATCHES_ADD_OUTGOING, {
        bankId,
        accountId,
        transactionId: result.id,
      });
    } else {
      url = generatePath(ROUTES.EXPORT_BATCHES_READ_OUTGOING, {
        bankId,
        accountId,
        batchId,
        transactionId: result.id,
      });
    }

    result.url = url;

    const render: Record<string, React.JSX.Element> = {
      transferDate: <div>{formatDate(result?.transferDate || '', true)}</div>,
      currencyId: <div>{result.currency?.name}</div>,
      sum: <div>{formatBalance(result.sum)}</div>,
      baseellaStatus: <div>{BaseellaStatusTitle[result.baseellaStatus]}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList || [];
};

export default formatExportList;
